export enum ESRJ_MODULE {
  INTRO = 'intro',
  INTRO_STEP1 = `${ESRJ_MODULE.INTRO}_1`,
  BASELINE = 'baseline',
  BASELINE_STEP1 = `${ESRJ_MODULE.BASELINE}_1`,
  BASELINE_STEP2 = `${ESRJ_MODULE.BASELINE}_2`,
  BASELINE_STEP3 = `${ESRJ_MODULE.BASELINE}_3`,
  CHECK_IN = 'checkin',
  MODULE1 = 'module1',
  MODULE1_CHAPTER1 = `${ESRJ_MODULE.MODULE1}_1`,
  MODULE1_CHAPTER1_STEP1 = `${ESRJ_MODULE.MODULE1_CHAPTER1}_1`,
  MODULE1_CHAPTER1_STEP2 = `${ESRJ_MODULE.MODULE1_CHAPTER1}_2`,
  MODULE1_CHAPTER1_STEP3 = `${ESRJ_MODULE.MODULE1_CHAPTER1}_3`,
  MODULE1_CHAPTER1_STEP4 = `${ESRJ_MODULE.MODULE1_CHAPTER1}_4`,
  MODULE1_CHAPTER2 = `${ESRJ_MODULE.MODULE1}_2`,
  MODULE1_CHAPTER2_STEP1 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_1`,
  MODULE1_CHAPTER2_STEP2 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_2`,
  MODULE1_CHAPTER2_STEP3 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_3`,
  MODULE1_CHAPTER2_STEP4 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_4`,
  MODULE1_CHAPTER2_STEP5 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_5`,
  MODULE1_CHAPTER2_STEP6 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_6`,
  MODULE1_CHAPTER2_STEP7 = `${ESRJ_MODULE.MODULE1_CHAPTER2}_7`,
  MODULE2 = 'module2',
  MODULE2_STEP1 = `${ESRJ_MODULE.MODULE2}_1`,
  MODULE2_STEP2 = `${ESRJ_MODULE.MODULE2}_2`,
  MODULE2_STEP2_A = `${ESRJ_MODULE.MODULE2_STEP2}_a`,
  MODULE2_STEP2_A_1 = `${ESRJ_MODULE.MODULE2_STEP2_A}_1`,
  MODULE2_STEP2_A_2 = `${ESRJ_MODULE.MODULE2_STEP2_A}_2`,
  MODULE2_STEP2_B = `${ESRJ_MODULE.MODULE2_STEP2}_b`,
  MODULE2_STEP2_B_1 = `${ESRJ_MODULE.MODULE2_STEP2_B}_1`,
  MODULE2_STEP2_B_2 = `${ESRJ_MODULE.MODULE2_STEP2_B}_2`,
  MODULE2_STEP2_B_3 = `${ESRJ_MODULE.MODULE2_STEP2_B}_3`,
  MODULE2_STEP3 = `${ESRJ_MODULE.MODULE2}_3`,
  MODULE2_STEP4 = `${ESRJ_MODULE.MODULE2}_4`,
  MODULE3 = 'module3',
  MODULE3_STEP1 = `${ESRJ_MODULE.MODULE3}_1`,
  MODULE3_STEP2 = `${ESRJ_MODULE.MODULE3}_2`,
  MODULE3_STEP2_A_1 = `${ESRJ_MODULE.MODULE3}_2_a_1`,
  MODULE3_STEP2_B_1 = `${ESRJ_MODULE.MODULE3}_2_b_1`,
  MODULE3_STEP2_C_1 = `${ESRJ_MODULE.MODULE3}_2_c_1`,
  MODULE3_STEP3 = `${ESRJ_MODULE.MODULE3}_3`,
  MODULE4 = 'module4',
  MODULE4_STEP1 = `${ESRJ_MODULE.MODULE4}_1`,
  MODULE4_STEP2 = `${ESRJ_MODULE.MODULE4}_2`,
  MODULE4_STEP2_A = `${ESRJ_MODULE.MODULE4_STEP2}_a`,
  MODULE4_STEP2_A_1 = `${ESRJ_MODULE.MODULE4_STEP2_A}_1`,
  MODULE4_STEP2_A_2 = `${ESRJ_MODULE.MODULE4_STEP2_A}_2`,
  MODULE4_STEP2_B = `${ESRJ_MODULE.MODULE4_STEP2}_b`,
  MODULE4_STEP2_B_1 = `${ESRJ_MODULE.MODULE4_STEP2_B}_1`,
  MODULE4_STEP2_B_2 = `${ESRJ_MODULE.MODULE4_STEP2_B}_2`,
  MODULE4_STEP3 = `${ESRJ_MODULE.MODULE4}_3`,
  EXTRA_MODULE = 'extra_module',
  FAQ = 'faq',
}
